import _ from 'lodash'
import Api from 'redux-apis'

import {
  commonChildApiProps,
} from './commonUtils'

const reduceFunctions = (state, payload, keyname) => {
  const funcs = _.reduce(
    payload,
    (res, fname) => {
      res[fname] = _.extend({argspec: null, doc: null}, (res[fname] || {}))
      return res
    },
    (state[keyname] || {}))
  //return funcs
  console.log(funcs)
  return {
    ...state,
    [keyname]: funcs
  }
}

const reduceDetail = (state, payload, keyname, detailName) => {
  return {
    ...state,
    [keyname]:_.reduce(
      payload,
      (res, detail, fname) => {
        res[fname] = _.extend(
          {argspec: null, doc: null},
          (res[fname] || {}),
          {[detailName]: detail})
        return res
      },
      (state[keyname] || {}))
  }
}

export default class Docs extends Api {
  constructor (saltApi) {
    super({functions: {}, runners: {}})

    Object.defineProperties(this, {
      ...commonChildApiProps(saltApi, this),

      // functions: {enumerable: true, get: () => this.getState().functions},
      // runners: {enumerable: true, get: () => this.getState().runners}
    })

    // Action handlers (reducers)
    this.setHandler('SET_FUNCTIONS', (state, action) => {
      console.log('handler SET_FUNCTIONS: ', state, action)
      return reduceFunctions(state, action.payload, 'functions')
      // const funcs = reduceFunctions(state, action.payload, 'functions')
      // return {
      //   ...state,
      //   functions:funcs
      // }
    })
    this.setHandler('SET_FUNCTION_ARGSPEC', (state, action) => (
      reduceDetail(state, action.payload, 'functions', 'argspec')
    ))
    this.setHandler('SET_FUNCTION_DOC', (state, action) => (
      reduceDetail(state, action.payload, 'functions', 'doc')
    ))

    this.setHandler('SET_RUNNER_FUNCTIONS', (state, action) => (
      reduceFunctions(state, action.payload, 'runners')
    ))
    this.setHandler('SET_RUNNER_ARGSPEC', (state, action) => (
      reduceDetail(state, action.payload, 'runners', 'argspec')
    ))
    this.setHandler('SET_RUNNER_DOC', (state, action) => (
      reduceDetail(state, action.payload, 'runners', 'doc')
    ))

    this.setHandler('SET_MODULES', (state, action) => (
      {...state, modules:action.payload}
    ))


    // this.setStateChanges(['SET_FUNCTIONS'], [allDocs])
  }

  initDocs(allDocs) {
    this.setStateChanges(
      ['SET_FUNCTION_ARGSPEC', 'SET_FUNCTION_DOC'],
      [
        _
          .chain(allDocs)
          .map((v, k) => [k, v.argspec])
          .fromPairs()
          .value(),
        _
          .chain(allDocs)
          .map((v, k) => [k, v.doc])
          .fromPairs()
          .value()
      ])
  }

  // listModules() {
  //   return this
  //     ._saltApi
  //     ._runOnMaster('sys.list_modules')
  //     .then(res => res[this._saltApi._saltMasterMinionId])
  //     .then(res => {
  //       // console.log('dispatching action SET_FUNCTIONS', res)
  //       // this.dispatch(this.createAction('SET_FUNCTIONS')(res))
  //       this.setStateChanges(['SET_MODULES'], [res])
  //       // console.log('dispatched action SET_FUNCTIONS', res)
  //       return res
  //     })
  // }

  // getAllArgSpecs() {
  //   const getMods = () => {
  //     let mods = this.getState().modules
  //     if (!_.isUndefined(mods) && _.size(mods) > 0)
  //       return Promise.resolve(mods)
  //     return this._saltApi._runOnMaster('sys.list_modules')
  //   }
  //   const getArgSpec = (mod) => {
  //     return this
  //       ._saltApi
  //       ._runOnMaster('sys.argspec', mod)
  //       .then(res => (
  //         _.isUndefined(res) ? {} : res[this._saltApi._saltMasterMinionId])
  //       )
  //   }

  //   const getAllUniqMods = () => {
  //     let mods = this.getState().modules
  //     if (!_.isUndefined(mods) && _.size(mods) > 0)
  //       return Promise.resolve(mods)
  //     return this
  //       ._saltApi
  //       ._run('*', 'sys.list_modules')
  //       .then(res => {
  //         let _mods = []
  //         for(let vals of _.values(res))
  //           _mods = _mods.concat(vals)
  //         return _.uniq(_mods)
  //       })
  //   }

  //   const getAllArgSpec = (mod) => {
  //     return this
  //       ._saltApi
  //       ._run('*', 'sys.argspec', mod)
  //       .then(res => {
  //         if(_.isUndefined(res)) return {}
  //         let _res = {}
  //         let _mids = _.keys(res)
  //         for(let mid of _mids) {
  //           if(_.isUndefined(res[mid])) { res[mid] = {} }
  //           for(let fname of _.keys(res[mid])) {
  //             if(_.isUndefined(_res[mid])) { _res[mid] = {}}
  //             _res[mid][fname] = {argspec: res[mid][fname], doc: null}
  //           }
  //         }
  //         return _res
  //       })
  //   }


  //   this._saltApi.setBusy()
  //   let res = {}
  //   getAllUniqMods()
  //     .then(mods => {

  //     })
  //     .then(this._saltApi.setDone)
  //     .catch(this._saltApi.setError)
  // }

  list_functions(fname) {
    return this
      ._saltApi
      ._runOnMaster('sys.list_functions', fname)
      .then(res => res[this._saltApi._saltMasterMinionId])
      .then(res => {
        // console.log('dispatching action SET_FUNCTIONS', res)
        // this.dispatch(this.createAction('SET_FUNCTIONS')(res))
        this.setStateChanges(['SET_FUNCTIONS'], [res])
        // console.log('dispatched action SET_FUNCTIONS', res)
        return res
      })
  }
  function_argspec(fname) {
    return this
      ._saltApi
      ._runOnMaster('sys.argspec', fname)
      .then(res => res[this._saltApi._saltMasterMinionId])
      .then(res => {
        this.setStateChanges(['SET_FUNCTION_ARGSPEC'], [res])
        // this.dispatch(this.createAction('SET_FUNCTION_ARGSPEC')(res))
        return res
      })
  }
  function_doc(fname) {
    return this
      ._saltApi
      ._runOnMaster('sys.doc', fname)
      .then(res => res[this._saltApi._saltMasterMinionId])
      .then(res => {
        this.setStateChanges(['SET_FUNCTION_DOC'], [res])
        // this.dispatch(this.createAction('SET_FUNCTION_DOC')(res))
        return res
      })
  }

  list_runner_functions(fname) {
    return this
      ._saltApi
      ._runOnMaster('sys.list_runner_functions', fname)
      .then(res => res[this._saltApi._saltMasterMinionId])
      .then(res => {
        this.setStateChanges(['SET_RUNNER_FUNCTIONS'], [res])
        // this.dispatch(this.createAction('SET_RUNNER_FUNCTIONS')(res))
        return res
      })
  }
  runner_argspec(fname) {
    return this
      ._saltApi
      ._runOnMaster('sys.runner_argspec', fname)
      .then(res => res[this._saltApi._saltMasterMinionId])
      .then(res => {
        this.setStateChanges(['SET_RUNNER_ARGSPEC'], [res])
        // this.dispatch(this.createAction('SET_RUNNER_ARGSPEC')(res))
        return res
      })
  }
  runner_doc(fname) {
    return this
      ._saltApi
      ._runOnMaster('sys.runner_doc', fname)
      .then(res => res[this._saltApi._saltMasterMinionId])
      .then(res => {
        this.setStateChanges(['SET_RUNNER_DOC'], [res])
        // this.dispatch(this.createAction('SET_RUNNER_DOC')(res))
        return res
      })
  }

}



// WEBPACK FOOTER //
// ./src/saltapi/Docs.js